// src/features/auth/signup/components/SignupSuccessModal.tsx

import React from 'react';

interface SignupSuccessModalProps {
  open: boolean;

  onLogin: () => void;
}

export default function SignupSuccessModal({
  open,
  onLogin,
}: SignupSuccessModalProps) {
  if (!open) {
    return null;
  }

  return (
    <div
      className="
        fixed inset-0 z-50
        flex items-center
        justify-center
        bg-black/60 px-4
        backdrop-blur-sm
      "
    >
      <div
        className="
          w-full max-w-sm
          rounded-2xl bg-white
          px-6 py-7 shadow-2xl
        "
      >
        <div
          className="
            mx-auto flex h-14 w-14
            items-center justify-center
            rounded-full
            bg-emerald-100
          "
        >
          <svg
            className="h-8 w-8 text-emerald-600"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h2
          className="
            mt-5 text-center
            text-xl font-bold
            text-gray-900
          "
        >
          회원가입이 완료되었습니다
        </h2>

        <p
          className="
            mt-3 text-center
            text-sm leading-7
            text-gray-600
          "
        >
          회원가입이 정상적으로
          완료되었습니다.
          <br />
          지금 바로 로그인하실 수
          있습니다.
        </p>

        <button
          type="button"
          onClick={onLogin}
          className="
            mt-6 flex min-h-11
            w-full items-center
            justify-center rounded-lg
            bg-main px-4 py-2.5
            text-sm font-semibold
            text-white transition

            hover:bg-main-medium
          "
        >
          로그인 화면으로 이동
        </button>
      </div>
    </div>
  );
}